module.exports = __webpack_public_path__ + "img/Blackberries.d8e02f77.png";